









































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMapLayer } from "./types";
import { isFunction, isMobile } from "@/common/utils";

const ICON_SIZE = isMobile() ? '20px' : '16px';
const ICON_SIZE2 = isMobile() ? '16px' : '12px';
const INDENT = isMobile() ? 28 : 24;

@Component({
  name: 'v-legend'
})
export default class extends Vue {
  @Prop({
    default: null
  }) parent: IMapLayer;
  @Prop({
    default: () => {
      return [];
    }
  }) items: IMapLayer[];
  @Prop({
    default: false
  }) showDivider: boolean;
  @Prop({
    default: () => { return 0; }
  }) depth: number;
  @Prop({
    default: 0
  }) indent: number;
  /*@Prop({
    default: true
  }) canRemoveLayer: boolean;*/

  get isMobile() : boolean {
    return isMobile();
  }

  created() {
    if (this.parent && this.items) {
      this.items.forEach((item) => {
        item.parent = item.parent || this.parent; //reserve original parent
      });
    }
  }

  showItemVisibility(item:IMapLayer) : boolean {
    return item.mapSources && item.mapSources.length>0;
  }

  showChildren(item:IMapLayer) : boolean {
    return item.children && item.children.length>0; // && (item.visible);
  }

  showLegend(item:IMapLayer) : boolean {
    let hasMs: boolean = false;
    if (item.legend && item.legend.length>0) {
      for (let i=0; i<item.legend.length && !hasMs; i++) {
        hasMs = this.hasMapSource(item.legend[i]);
      }
    }
    return hasMs || item.visible;
    //return item.legend && item.legend.length>0 && item.visible;
  }

  hasChildren(item:IMapLayer) : boolean {
    return item.legend && item.legend.length>0;
  }

  hasMapSource(item:IMapLayer) : boolean {
    return item.mapSources && item.mapSources.length>0;
  }

  hasActions(item:IMapLayer) : boolean {
    return (item.showCtrls!==false) && 
           (!!item.actions || !!item.type || this.hasMapSource(item)); // || (item.visible!==undefined);
  }

  canRemove(item:IMapLayer) : boolean {
    return !!item.type && (
            (item.children && item.children.length>0) ||
            (item.legend && item.legend.length>0) ||
            !item.parent || 
            (item.parent && !item.parent.type)
            );
  }

  hasStyle(item:IMapLayer) : boolean {
    //return !!item.style || !!item.icons || !!item.image || !!item.className;
    let hasStyle:boolean = false;
    let i;
    for (i=0; i<this.items.length; i++) {
      let item = this.items[i];
      if (!!item.style || !!item.icons || !!item.image || !!item.className) {
        hasStyle = true;
        break;
      }
    }
    return hasStyle;
  }

  itemStyle(item:IMapLayer) : {[key:string] : any} {
    return item.style || {};
  }

  itemClass(item:IMapLayer) : string {
    let c = 'v-tree-item__style';
    c += item.className ? (' ' + item.className) : '';
    c += item.image && item.image.match(/\.svg$/i) ? ' svg-image' : '';
    return c;
  }

  get SubTreeIndent() : number {
    let i,indent: number = this.depth===0 ? INDENT : 0; //this.indent;
    let hasStyle: boolean = false;
    for (i=0; i<this.items.length; i++) {
      if (this.hasStyle(this.items[i])) {
        indent = INDENT; // (20 width + 8 margin-right) refer to this.item.Style()
        hasStyle = true;
        break;
      }
    };
    //if (!hasStyle && !indent) {
    //  indent = 12;
    //}
    return indent;
  }

  updateParent(item:IMapLayer, visible:boolean, checked:boolean) {
    /*if (this.hasMapSource(item)) {
      let visible = false;
      item.mapSources.forEach((ms) => {
        if (ms.visible!==false) {
          visible = ms.visible;
          return;
        }
      });
      if (item.visible!==visible) {
        item.visible = visible;
        //item.checked = item.visible;
        ////this.setItemVisibility(item);
        if (item.parent) {
          item.parent.checked = item.checked;
          this.updateParent(item.parent);
        }
      }
    }*/
    if (item.type) {
      item.visible = visible;
      item.checked = checked;
    }
    if (item.parent) {
      this.updateParent(item.parent, visible, checked);
    }
  }

  updateChild(children:IMapLayer[], visible:boolean, checked:boolean) {
    children.forEach((item) => {
      if (this.hasMapSource(item)) {
        if (item.visible!==visible) {
          item.visible = visible;
          item.checked = checked;
          //item.checked = item.visible;
          ////this.setItemVisibility(item);
          if (item.children && item.children.length>0) {
            this.updateChild(item.children, visible, checked);
          } else if (item.legend && item.legend.length>0) {
            this.updateChild(item.legend, visible, checked);
          }
        }
      }
    }, this);
  }

  setItemVisibility(item:IMapLayer) {
    item.mapSources.forEach((ms) => {
      ms.visible = item.visible;
      if (ms.nativeLayer) {
        if (isFunction(item.onVisibilityChange)) {
          item.onVisibilityChange.call(item, ms.visible);
        } else {
          ms.nativeLayer.setVisible(ms.visible);
        }
      }
    });
  }

  onActionSelectionChange(item, action) {
    let selection = null;
    for (let i=0; i<action.options.length && !selection; i++) {
      if (action.options[i].value==action.selected) {
        selection = action.options[i];
      }
    }
    if (isFunction(action.do)) {
      action.do.call(item, selection);
    } else {
      this.$emit('action', {item:item, action:{
        action: 'changeActionSelection',
        selection: selection
      }});
    }
  }

  doAction(item, action) {
    if (!!action.action.match(/changeVisibility|removeLayer/)) {
      if (action.action=='removeLayer') {
        item.checked = false;
        item.visible = false;
      } else {
        item.visible = !item.visible;
      }
      if (this.hasMapSource(item)) {
        this.setItemVisibility(item);
      }
      if (item.parent) {
        this.updateParent(item.parent, item.visible, item.checked);
      }
      if (item.children && item.children.length>0) {
        this.updateChild(item.children, item.visible, item.checked);
      } else if (item.legend && item.legend.length>0) {
        this.updateChild(item.legend, item.visible, item.checked);
      }
    }
    if (isFunction(item.doAction)) {
      item.doAction({item:item, action:action});
    } else {
      this.$emit('action',{item:item, action:action});
    }
  }
}
